import * as React from "react";
import type { SVGProps } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
  desc?: string;
  descId?: string;
}
const SvgMicrophoneIcon = ({
  title,
  titleId,
  desc,
  descId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    aria-hidden="true"
    data-slot="icon"
    width={24}
    height={24}
    aria-labelledby={titleId}
    aria-describedby={descId}
    {...props}
  >
    {desc ? <desc id={descId}>{desc}</desc> : null}
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M18 10.2V12c0 3.4794-2.6863 6.3-6 6.3m-6-8.1V12c0 3.4794 2.6863 6.3 6 6.3m0 0V21m-3.4286 0h6.8572M12 14.7c-1.4202 0-2.5714-1.2088-2.5714-2.7V5.7C9.4286 4.2088 10.5798 3 12 3s2.5714 1.2088 2.5714 2.7V12c0 1.4912-1.1512 2.7-2.5714 2.7"
    />
  </svg>
);
export default SvgMicrophoneIcon;
